export default __webpack_public_path__ + "static/media/fondo-login-dtm.29cce40b.png";